import { Link } from 'react-router-dom'
import { Compass, ArrowLeft } from 'lucide-react'

/**
 * Page 404 — rendue par la route catch-all (`path="*"`).
 *
 * Elle est montee soit dans un AppLayout (sidebar + navigation presentes,
 * l'utilisateur peut rebondir), soit seule a la racine quand l'URL inconnue
 * ne tombe dans aucun groupe de routes.
 */
export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <div className="w-20 h-20 rounded-2xl bg-white border border-[#E2E4ED] flex items-center justify-center mb-5">
        <Compass className="w-9 h-9 text-[#555A73]" strokeWidth={1.25} />
      </div>

      <span className="text-xs font-semibold tracking-widest text-[#8B8FA7] mb-2">
        ERREUR 404
      </span>

      <h2 className="text-xl font-bold text-[#1B2559] mb-2">Page introuvable</h2>

      <p className="text-[#8B8FA7] text-sm max-w-md">
        Cette adresse ne correspond a aucune page d'Orion. Elle a peut-etre ete
        deplacee, ou le lien que vous avez suivi est errone.
      </p>

      <Link
        to="/projects"
        className="mt-6 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-orion-primary text-white text-sm font-medium hover:opacity-90 transition-opacity"
      >
        <ArrowLeft className="w-4 h-4" strokeWidth={2} />
        Retour a l'accueil
      </Link>
    </div>
  )
}
